module.exports = __webpack_public_path__ + "static/media/thumbs-down.c699aa32.svg";